import { useState, useEffect } from "react";
import { fetchNumberOneRecommendationData, type TimeRange, type NumberOneRecommendationData } from "@/app/services/analytics/number-one-recommendation-api";
import { useAnalyticsRefreshTrigger } from "./useAnalyticsRefreshTrigger";

export function useNumberOneRecommendationData(
  timeRange: TimeRange,
  antennaData?: any,
  selectedModels?: string[],
) {
  const [data, setData]           = useState<NumberOneRecommendationData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError]         = useState<Error | null>(null);
  const refreshKey                = useAnalyticsRefreshTrigger();

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    setError(null);
    fetchNumberOneRecommendationData(timeRange, antennaData, selectedModels)
      .then(r  => { if (!cancelled) { setData(r); setIsLoading(false); } })
      .catch(e => { if (!cancelled) { setError(e instanceof Error ? e : new Error(String(e))); setIsLoading(false); } });
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeRange, refreshKey]);

  return { data, isLoading, error };
}